import { Link } from 'react-router-dom';
import { ArrowRight, Award } from 'lucide-react';
import { Layout } from '../components/layout/Layout';
import { HeroCarousel } from '../components/home/HeroCarousel';
import { FeaturePanels } from '../components/home/FeaturePanels';
import { LatestNews } from '../components/home/LatestNews';
import { UpcomingEvents } from '../components/home/UpcomingEvents';
import { Button } from '../components/ui/button';
import { Badge } from '../components/ui/badge';

// Centenary Preview Data
const centenaryHighlights = [
  { year: '1926', title: 'CPRE Founded', image: '/images/cpre images for website/20.png' },
  { year: '1949', title: 'National Parks Act', image: '/images/cpre images for website/15.jpg' },
  { year: '1990', title: 'Rutland Water Protection', image: '/images/cpre images for website/2.jpg' },
  { year: '2026', title: 'Centenary Year', image: 'https://images.unsplash.com/photo-1719909871645-cc4977336274?w=400' },
];

const HomePage = () => {
  return (
    <Layout>
      <div data-testid="home-page">
        {/* 1. Hero Carousel - Centenary Focus */}
        <HeroCarousel />
        
        {/* 2. Three Feature Panels - Centenary Projects, Volunteer, Planning Alerts */}
        <FeaturePanels />

        {/* Centenary Timeline Preview */}
        <section className="section-padding bg-cpre-new-yew" data-testid="centenary-preview">
          <div className="container-custom">
            <div className="text-center mb-10">
              <Badge className="bg-cpre-harvest-gold text-cpre-new-yew hover:bg-cpre-autumn-leaf hover:text-white mb-4">
                <Award className="w-4 h-4 mr-2 inline" />
                1926 — 2026
              </Badge>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-3">
                100 Years of Countryside Protection
              </h2>
              <p className="text-white/70 max-w-xl mx-auto">
                Explore our journey from 1926 to today
              </p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mb-10">
              {centenaryHighlights.map((item, index) => (
                <Link key={index} to="/centenary" className="group">
                  <div className="relative aspect-[4/3] rounded-xl overflow-hidden">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-cpre-new-yew via-transparent to-transparent" />
                    <div className="absolute bottom-0 left-0 right-0 p-4">
                      <span className="text-cpre-harvest-gold font-bold text-2xl md:text-3xl">{item.year}</span>
                      <p className="text-white text-sm mt-1 line-clamp-1">{item.title}</p>
                    </div>
                  </div>
                </Link>
              ))}
            </div>

            <div className="text-center">
              <Link to="/centenary">
                <Button size="lg" className="bg-cpre-harvest-gold hover:bg-cpre-harvest-gold/90 text-cpre-new-yew rounded-full px-8">
                  Explore Our History
                  <ArrowRight className="w-5 h-5 ml-2" />
                </Button>
              </Link>
            </div>
          </div>
        </section>
        
        {/* 3. Latest News Feed */}
        <LatestNews />
        
        {/* 4. Upcoming Events Strip */}
        <UpcomingEvents />
      </div>
    </Layout>
  );
};

export default HomePage;
